<script>
import Notification from "@/components/reUse/Notification.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "NastavitvePregledi",
  components: {Multiselect, Notification},
  data() {
    return {
      klubi: [],
      izbranKlub: null,
      izbranNaziv: null,
      prikazDni: 0,
      naziv: [
        { 'lvl': 2 ,
          'naziv': 'Instruktor'
        },
        // { 'lvl': 3 ,
        //   'naziv': 'Kronometrist'
        // },
      ],
      casovnica: false,
      text: '',
      types: '',
      ShowNoti: false,
      brisanje: false,
      posodabljam: false,
      berem: false
    }
  },
  mounted() {
    this.BeriKlube();
  },
  methods: {
    BeriKlube() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi;
      }).catch((napaka) => {
        if (napaka !== undefined && napaka.response.data.napaka !== null) {
          this.text = napaka.response.data.napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        } else {
          this.text = napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        }
      });
    },
    BeriNastavitev() {
      this.berem = true;
      let podatki = new URLSearchParams();
      podatki.append('klub', this.izbranKlub.id);
      podatki.append('nivo', this.izbranNaziv.lvl);
      axios.post('./api/nastavitve/upravitelj/nivo/beri/', podatki, {withCredentials: true}).then((response) => {
        this.prikazDni = response.data.dni;
        this.casovnica = true;
        this.berem = false;
      }).catch((napaka) => {
        this.berem = false;
        if (napaka !== undefined && napaka.response.data.napaka !== null) {
          this.text = napaka.response.data.napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        } else {
          this.text = napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        }
      })
    },
    izpisKluba ({naziv, sifra}) {
      return `${naziv} [${sifra}]`
    },
    izpisNaziva({lvl, naziv}) {
      return `${naziv} [${lvl}]`
    },
    PotrdiIzbiro() {
      if(this.izbranKlub !== null && this.izbranNaziv !== null) {
        this.BeriNastavitev();
      }else {
        this.casovnica = false;
      }
    },
    Shrani() {
      this.posodabljam = true;
      let podatki = new URLSearchParams();
      podatki.append('klub', this.izbranKlub.id);
      podatki.append('nivo', this.izbranNaziv.lvl);
      podatki.append('dni', this.prikazDni);
      axios.post('./api/nastavitve/upravitelj/nivo/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.posodabljam = false;
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        if (napaka !== undefined && napaka.response.data.napaka !== null) {
          this.text = napaka.response.data.napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        } else {
          this.text = napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        }
      });
    }
  }
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <main class="main-content" >
      <div class="card-pregled">

        <!-- HEADER -->

        <div class="header-pregled">
          <h1>Nastavitev pregledov nivoja uporabnika</h1>
          <p>
            Nastavi obdobje dostopa do zapisov glede na klub in nivo.
          </p>
        </div>

        <!-- Izbira nivoja in kluba -->
        <div class="step-content active" id="step1">

          <div class="field">

            <label>Pridobi klub</label>

            <div class="field-description">
              Poišči klub za urejanje nastavitev.
            </div>

            <div class="club-search">
              <multiselect v-model="izbranKlub"
                           :options="klubi"
                           :custom-label="izpisKluba"
                           track-by="id"
                           @select="PotrdiIzbiro()"
                           @remove="PotrdiIzbiro()"
                           placeholder="Izberi / najdi klub"
              >
                <template #noResult>
                  Klub ne obstaja
                </template>

              </multiselect>

            </div>

          </div>


          <div class="field">

            <label for="title">
              Naziv nivoja
            </label>

            <div class="field-description">
              Nivo uporabnika, ki ga boste urejali
            </div>

            <multiselect v-model="izbranNaziv"
                         :options="naziv"
                         :custom-label="izpisNaziva"
                         track-by="lvl"
                         @select="PotrdiIzbiro()"
                         @remove="PotrdiIzbiro()"
                         placeholder="Izberi / najdi nivo"
            >
              <template #noResult>
                Klub ne obstaja
              </template>

            </multiselect>

          </div>


        </div>


        <!-- STEP 2 -->

        <div class="step-content" v-show="casovnica">
          <div class="field" v-if="berem">
            <label>Časovnica zapisov</label>

            <div class="field-description">
              Določi, koliko dni nazaj lahko uporabnik dostopa do zapisov.
            </div>

            <div class="timeline-box">

              <div class="timeline-value">
                <strong id="daysValue"><i class="fas fa-spinner fa-spin text-white"></i></strong>
              </div>

              <input
                  class="inputDni"
                  type="range"
                  id="days"
                  min="1"
                  max="365"
                  value="30"
                  disabled
                  v-model="prikazDni"
              >

              <div class="range-labels">
                <span>1 dan</span>
                <span>365 dni</span>
              </div>

            </div>
          </div>
          <div class="field" v-else>

            <label>Časovnica zapisov</label>

            <div class="field-description">
              Določi, koliko dni nazaj lahko uporabnik dostopa do zapisov.
            </div>

            <div class="timeline-box">

              <div class="timeline-value">
                <strong id="daysValue">{{ prikazDni }}</strong>
                <span>dni nazaj</span>
              </div>

              <input
                  class="inputDni"
                  type="range"
                  id="days"
                  min="1"
                  max="365"
                  value="30"
                  v-model="prikazDni"
              >

              <div class="range-labels">
                <span>1 dan</span>
                <span>365 dni</span>
              </div>

            </div>

          </div>


          <div class="actions">
            <button
                class="users-modern-btn users-modern-btn-primary"
                @click.prevent="Shrani()"
                :disabled="posodabljam"
            >
              <i class="fas fa-sync-alt" :class="{'fa-spin': posodabljam}"></i>
              Posodobi
            </button>

          </div>

        </div>

      </div>
    </main>
    <div class="w-100 mt-4"></div>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
</template>
<style>
/* CARD */

.card-pregled {
  width: 100%;
  max-width: 100%;

  background: #2f3a45;
  color: white;

  border-radius: 14px;
  padding: 32px;

  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

/* header-pregled */

.header-pregled {
  margin-bottom: 28px;
}

.header-pregled p {
  margin: 0;
  color: #aeb7c1;
  font-size: 14px;
  line-height: 1.5;
}

.step.active .step-number {
  background: #ffffff;
  color: #2f3a45;
}

.field {
  margin-bottom: 22px;
}

.field label {
  display: block;
  margin-bottom: 8px;

  font-size: 13px;
  font-weight: 600;
}

.field-description {
  margin: -2px 0 10px;

  color: #aeb7c1;
  font-size: 13px;
  line-height: 1.5;
}

input.inputDni {
  width: 100%;
  height: 44px;

  padding: 0 12px;

  border: 1px solid #596571;
  border-radius: 7px;

  background: #26313b;
  color: white;

  font-size: 14px;

  outline: none;
}

input.inputDni:focus,

/* CLUB */

.club-search {
  display: flex;
  gap: 8px;
}

.club-search input {
  flex: 1;
}


.club-result strong {
  display: block;
  font-size: 14px;
  margin-bottom: 3px;
}

.club-result span {
  color: #aeb7c1;
  font-size: 12px;
}

/* TIMELINE */

.timeline-box {
  padding: 18px;

  background: #26313b;
  border: 1px solid #596571;
  border-radius: 8px;
}

.timeline-value {
  display: flex;
  align-items: baseline;
  gap: 6px;

  margin-bottom: 18px;
}

.timeline-value strong {
  font-size: 30px;
  font-weight: 600;
}

.timeline-value span {
  color: #aeb7c1;
  font-size: 14px;
}

input[type="range"] {
  width: 100%;
  height: 5px;

  padding: 0;

  border: 0;
  border-radius: 5px;

  background: #596571;

  accent-color: white;
  cursor: pointer;
}

.range-labels {
  display: flex;
  justify-content: space-between;

  margin-top: 8px;

  color: #8995a1;
  font-size: 11px;
}

/* BUTTONS */

.actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;

  margin-top: 30px;
}

.button {
  height: 42px;
  padding: 0 20px;

  border-radius: 7px;

  font-size: 13px;
  font-weight: 600;

  cursor: pointer;
}

.button.secondary {
  border: 1px solid #596571;
  background: transparent;
  color: white;
}

.button.primary {
  margin-left: auto;

  border: 0;
  background: white;
  color: #2f3a45;
}

.button:hover {
  opacity: 0.9;
}

/* SUCCESS */

.success {
  display: none;
  text-align: center;
  padding: 20px 0;
}

.success.show {
  display: block;
}

.success-icon {
  width: 45px;
  height: 45px;

  margin: 0 auto 15px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: #ffffff;
  color: #2f3a45;

  font-size: 20px;
}

.success h2 {
  margin: 0 0 6px;
  font-size: 20px;
}

.success p {
  margin: 0;
  color: #aeb7c1;
  font-size: 13px;
}

/* MOBILE */

@media (max-width: 600px) {
  body {
    padding: 15px;
  }

  .card-pregled {
    padding: 24px;
  }

  .step span {
    display: none;
  }
}
</style>